import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';

const flavorContextCss = ":host{display:contents}";

const FlavorContext = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.flavor = 'core';
  }
  render() {
    return h("slot", null);
  }
  static get style() { return flavorContextCss; }
}, [1, "tt-flavor-context", {
    "flavor": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-flavor-context"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-flavor-context":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, FlavorContext);
      }
      break;
  } });
}

const TtFlavorContext = FlavorContext;
const defineCustomElement = defineCustomElement$1;

export { TtFlavorContext, defineCustomElement };
